<template>
  <span class="icon icon-reset" :title="$t('button.reset')" @click="doReset"></span>
</template>

<script>
import('@/styles/components/reset-button.less')

export default {
  name: 'BaseResetButton',
  props: {
    value: {
      required: false
    },
    resetValue: {
      required: false,
      default: null
    }
  },
  data: () => ({}),
  methods: {
    doReset() {
      if (!this.value) {
        this.$emit('input')
        return
      }
      if (Array.isArray(this.value)) {
        this.$emit('input', [])
      } else {
        this.$emit('input', this.resetValue)
      }
    }
  }
}
</script>
